import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { TableRow, TableHead, TableCell, TableBody, Button, Typography } from '@material-ui/core';
import SingleTransferTemplate from '../singleTemplates/SingleTransferTemplate';
import { TableLayout } from '../../containers/Layout';
import { fetchTransferDetails } from '../../../../../../../../jsx/actions/transferAction';

const SingleTransferCommercial = (props) => {
    const dispatch = useDispatch();
    const PRODUCTS = useSelector((state) => state.inventory.products); 
    const [details, setDetails] = useState({})

    useEffect(() => {
        const fetchTransferData = async () => {
            try {
                const transferData = await dispatch(fetchTransferDetails(props.transfer.id));
                setDetails(transferData);
            } catch (error) {
                console.error('Error fetching transfer details:', error);
            }
        };
        
        fetchTransferData();
    }, [dispatch, props.transfer.id]);

    const createProductList = () => {
        return !isEmpty(details) && details.products.map(item => {
            const product = PRODUCTS && PRODUCTS[item.product_id];
            return (
                <TableRow key={item.product_id}>
                    <TableCell>{product?.name || `Product ID: ${item.product_id}`}</TableCell>
                    <TableCell>{item.quantity}</TableCell>
                </TableRow>
            );
        });
    };

    return (
        <SingleTransferTemplate
            shop={props.shop}
            commercial={props.commercial}
            transfer={details}
            notif={props.notif}
        >
            <TableLayout>
                <TableHead>
                    <TableRow>
                        <TableCell>Produit</TableCell>
                        <TableCell>Quantité</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {createProductList()}
                    <TableRow>
                        <TableCell colSpan={2}></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>TRANSPORT</TableCell>
                        <TableCell>{details.transport || 0}</TableCell>
                    </TableRow>
                </TableBody>
            </TableLayout>
        </SingleTransferTemplate>
    );
};

export default SingleTransferCommercial;
